import { render, staticRenderFns } from "./R8.vue?vue&type=template&id=65f3c01c&scoped=true"
import script from "./R8.vue?vue&type=script&lang=js"
export * from "./R8.vue?vue&type=script&lang=js"
import style0 from "./R8.vue?vue&type=style&index=0&id=65f3c01c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3c01c",
  null
  
)

export default component.exports